
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Innovacabforweddinginpune() {



    const cardData =
    {
        keyword: ' Innova Cab for Wedding in Pune',
        heading: 'Prince Cabs: Innova Cab for Wedding in Pune',
        headingDescription: 'Prince Cabs offers premium Innova Cab for Wedding in Pune, ensuring stylish, comfortable, and reliable travel for your special day. Our spacious and well-maintained Innova and Innova Crysta vehicles are perfect for wedding guests, family members, and bridal travel. With professional chauffeurs, punctual service, and flexible booking options, we make wedding transportation hassle-free and convenient. Choose Prince Cabs’ trusted Innova cab service in Pune for weddings to add comfort, elegance, and reliability to your celebrations.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was once the seat of the powerful Peshwas of the Maratha Empire. Though much of it was destroyed by fire in 1828, its grand gates, massive walls, and sprawling gardens still stand tall. The evening light-and-sound show brings alive tales of Maratha bravery. Visitors enjoy exploring its ruins and imagining its glorious past. It is a must-visit landmark for history lovers in Pune. Shaniwar Wada is the perfect blend of legend and architecture."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is an architectural marvel with deep historical importance. During the Quit India Movement, Mahatma Gandhi, Kasturba Gandhi, and Sarojini Naidu were imprisoned here. The palace now houses a museum with artifacts, photos, and personal belongings of Gandhi. Its sprawling gardens provide a peaceful retreat for visitors. It is a national monument of pride and sacrifice. The palace stands as a timeless reminder of India’s freedom struggle."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is a historic hill fortress famous for the 1670 Battle of Sinhagad. The fort’s ruins, bastions, and watchtowers tell stories of Maratha valor. Trekkers enjoy scenic routes, especially during monsoon when the hills turn lush green. From the summit, panoramic views of the Sahyadris are breathtaking. Local vendors sell traditional pithla-bhakri, adding to the fort experience. It is a favorite among history enthusiasts and nature lovers."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious landmark, dedicated to Lord Ganesha. The idol is adorned with gold and jewels, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple is decorated with grandeur and cultural programs. It is also involved in various charitable activities. The temple’s central location makes it easily accessible. It is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill, one of Pune’s highest points, offers panoramic views of the entire city. At its summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. The climb of more than 100 steps is rewarding with peace and spirituality at the top. The Peshwa Museum nearby adds historical depth. Sunrises and sunsets from the hill are especially captivating. It is a serene escape from the city’s hustle."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features massive pillars, a stone-carved Nandi, and an unfinished mandapa. Despite being in the city center, it offers a peaceful environment. The temple is a fine example of Rashtrakuta-era architecture. Visitors often come here for meditation and photography. It remains a hidden gem in Pune’s heritage map."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove of over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include musical instruments, sculptures, everyday objects, and the recreated Mastani Mahal. The museum reflects the cultural richness of Maharashtra and India. It fascinates both art lovers and historians alike. Its three-storey building itself is a heritage attraction. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. Visitors from across the globe come here for meditation, wellness therapies, and yoga. Surrounded by serene gardens and modern architecture, it offers a peaceful escape. The ashram promotes holistic well-being and personal growth. Its vibrant international community adds cosmopolitan charm. It is a unique blend of spirituality and modern lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity, located in Viman Nagar, is Pune’s largest lifestyle and shopping mall. It houses hundreds of international and Indian brands, offering a world-class retail experience. Entertainment includes multiplex cinemas, gaming zones, and live events. The mall also features a wide range of restaurants and cafés. Seasonal festivals like Diwali and Christmas add vibrancy. It is the ultimate hub for shopping, dining, and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a scenic spot surrounded by hills. The reservoir supplies water to the city and offers natural beauty. Families enjoy picnics, boating, and street food near the dam. Monsoon enhances its charm with mist and greenery. Evenings here are especially peaceful with cool breezes. It is a refreshing escape for city dwellers."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by Mulshi Dam, is a serene outstation spot near Pune. It is surrounded by Sahyadri hills, forests, and waterfalls. Visitors enjoy camping, nature walks, and photography here. During monsoon, the lake looks spectacular with overflowing water and lush valleys. Eco-resorts nearby offer a comfortable stay amidst nature. It is ideal for couples, families, and adventure seekers."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Located on Senapati Bapat Road, Chaturshringi Temple is one of Pune’s oldest and most revered shrines. Dedicated to Goddess Chaturshringi (Durga), it requires devotees to climb over 100 steps to reach the sanctum. The temple is especially grand during Navratri with vibrant celebrations. It attracts devotees from all over Maharashtra. The views from the hilltop add to its charm. It is both a spiritual and cultural landmark."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "This war memorial is dedicated to Indian soldiers who sacrificed their lives post-independence. It displays tanks, weapons, and war memorabilia. The museum inside narrates stories of India’s military history. Visitors attend the evening flag retreat ceremony, which is deeply moving. It is both educational and inspiring for families and students. The memorial instills pride and patriotism."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a lush botanical park in Pune. Managed by the Agri-Horticultural Society, it houses exotic trees, flower nurseries, and shaded walking paths. Families come here for picnics and relaxation. The annual flower show is a highlight for nature lovers. It is one of Pune’s oldest gardens with colonial-era history. A green oasis in the bustling city, it offers peace and tranquility."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, Pune’s highest hill, is a popular trekking and jogging destination. The hilltop offers panoramic views of the entire city. It is rich in biodiversity, with birds, trees, and fresh air. Fitness enthusiasts flock here for morning walks and cycling. Sunrises and sunsets from Vetal Hill are breathtaking. It is Pune’s natural lung and a much-needed retreat for nature lovers."
  }
],


"services": [
    {
        "name": "Innova Crysta for Wedding",
        "description": "Make your special day memorable with our premium Innova Crysta wedding car service. Spacious, elegant, and comfortable, perfect for the bride, groom, and wedding party. Our professional chauffeurs ensure timely arrivals and smooth rides, adding a touch of luxury and style to your wedding celebrations."
    },
    {
        "name": "Innova Hire for Wedding",
        "description": "Hire Innova Crysta vehicles for weddings and related ceremonies in Pune. Our well-maintained cars come with experienced drivers who understand the importance of punctuality and decorum. Ideal for transporting family members, guests, and the bridal party in comfort and style."
    },
    {
        "name": "Innova Crysta Wedding Car Rental Pune",
        "description": "Affordable and luxurious Innova Crysta wedding car rentals in Pune, designed to meet all your wedding transportation needs. From pick-up to drop-off, enjoy a hassle-free experience with our professional drivers and immaculate vehicles, perfect for traditional and modern weddings alike."
    },
    {
        "name": "Innova Crysta Package",
        "description": "Customized wedding packages featuring Innova Crysta vehicles, including decor options and multiple pickups/drop-offs. Whether you need cars for the bridal party, family, or guests, our packages ensure smooth coordination, timely service, and a grand experience at competitive rates."
    },
    {
        "name": "Innova Cab on Rent for Wedding in Pune",
        "description": "Rent Innova Crysta cabs for weddings in Pune with flexible rental hours and easy booking. Our cars are spacious and comfortable, suitable for bridal parties and guests alike. Enjoy prompt service and luxury travel on your special day with courteous drivers."
    },
    {
        "name": "Toyota Innova Crysta Cab for Marriage",
        "description": "Travel in style with Toyota Innova Crysta cabs specifically tailored for marriage events. Our fleet is meticulously maintained, ensuring a clean and elegant ride. Professional drivers guarantee timely pickups and smooth transportation for the entire wedding procession."
    },
    {
        "name": "Luxury Innova Wedding Cab",
        "description": "Opt for a luxury Innova wedding cab service that adds sophistication to your wedding celebrations. Featuring premium interiors, flawless decor, and courteous drivers, our cabs offer the perfect blend of comfort and elegance for the bride, groom, and guests."
    },
    {
        "name": "7 Seater Innova for Marriage Pune",
        "description": "Spacious 7-seater Innova cabs available for marriage transportation needs in Pune. Ideal for families and small groups attending the wedding, these vehicles provide ample space, comfort, and a smooth ride, ensuring everyone travels together without hassle."
    },
    {
        "name": "Innova Crysta Bridal Car",
        "description": "Specialized Innova Crysta bridal car services with elegant decoration and premium comfort. Our bridal cars are perfect for the bride's arrival and departure, offering a memorable and stylish ride with professional chauffeurs who prioritize your special day."
    },
    {
        "name": "Innova Wedding Car Decoration Pune",
        "description": "Enhance your wedding car with beautiful and tasteful decoration services in Pune. We offer custom floral and accessory decor for Innova Crysta vehicles to make your wedding ride stand out, ensuring your car matches the grandeur of your celebration."
    },
    {
        "name": "Affordable Innova Wedding Cab",
        "description": "Get affordable Innova wedding cab services without compromising on quality or luxury. Our competitively priced packages include professional drivers, well-maintained vehicles, and optional decoration services, making your wedding transportation smooth, comfortable, and budget-friendly."
    }
],
"tableData": [
    ["Innova Crysta for Wedding", "Innova Hire for Wedding"],
    ["Innova Crysta Wedding Car Rental Pune", "Innova Crysta Package"],
    ["Innova Cab on Rent for Wedding in Pune", "Toyota Innova Crysta Cab for Marriage"],
    ["Luxury Innova Wedding Cab", "7 Seater Innova for Marriage Pune"],
    ["Innova Crysta Bridal Car", "Innova Wedding Car Decoration Pune"],
    ["Affordable Innova Wedding Cab", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Elegant Innova Cab Service for Weddings in Pune",
        "WhyChoosedescription": "Prince Cabs offers premium Innova cab services specially tailored for weddings and related events in Pune. Whether you need stylish and spacious transportation for the bride and groom, family members, or guests, our Innova cabs provide a comfortable, elegant, and reliable ride to make your special day flawless."
    },
    {
        "WhyChooseheading": "Well-Maintained and Immaculate Vehicles",
        "WhyChoosedescription": "Our Innova fleet is meticulously cleaned and maintained to ensure pristine condition on your wedding day. Each vehicle is equipped with plush seating, ample legroom, and tasteful interiors that match the grandeur of your celebration, offering a luxurious travel experience."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Professionalism and Discretion",
        "WhyChoosedescription": "Our drivers understand the importance of weddings and maintain utmost professionalism, punctuality, and discretion. They are trained to provide courteous service and handle the logistics smoothly, ensuring timely arrivals and departures throughout your wedding events."
    },
    {
        "WhyChooseheading": "Flexible Wedding Packages Customized for Your Needs",
        "WhyChoosedescription": "Prince Cabs offers customizable Innova cab packages for weddings, including single trips, multiple-day rentals, and coordination for various ceremonies. We work closely with you to plan routes, timings, and special requirements to guarantee a seamless travel experience."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Our pricing for wedding Innova cabs in Pune is competitive and transparent. You receive clear fare estimates upfront, covering all charges including driver allowance, tolls, and taxes, allowing you to budget confidently without unexpected costs."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support for Stress-Free Booking",
        "WhyChoosedescription": "Our dedicated wedding travel support team is available to assist you from initial booking through the day of the event. We ensure timely updates, smooth coordination, and quick responses to any last-minute changes, making your wedding transportation hassle-free."
    }
]





























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Innova cabs for weddings in Pune?',
        answer: 'Yes, Prince Cabs offers premium Innova and Innova Crysta cabs specially arranged for weddings, ensuring stylish and comfortable travel for the bride, groom, and guests.',
    },
    {
        question: 'Can I get decorated Innova cabs for wedding occasions?',
        answer: 'Absolutely! We provide decorated Innova cabs with floral arrangements and ribbons on request to add a festive and elegant touch to your wedding transportation.',
    },
    {
        question: 'How many passengers can an Innova cab accommodate for a wedding?',
        answer: 'Innova cabs comfortably seat 6 to 7 passengers, making them ideal for small groups or family members traveling together during weddings.',
    },
    {
        question: 'Are wedding Innova cabs available for hourly rental in Pune?',
        answer: 'Yes, you can book Innova cabs on an hourly basis for wedding day services, including pickup, drop, and multiple venue travel within Pune.',
    },
    {
        question: 'Do you provide chauffeurs trained for wedding events?',
        answer: 'Yes, our professional drivers are courteous, punctual, and trained to handle wedding day schedules with care and respect.',
    },
    {
        question: 'How can I book an Innova cab for my wedding in Pune?',
        answer: 'Booking is simple—contact us via phone or our website with your wedding date and requirements. We will ensure timely and elegant Innova cab service for your special day.',
    },
    {
        question: 'Are the Innova cabs sanitized and well-maintained for weddings?',
        answer: 'Yes, all vehicles are thoroughly cleaned and sanitized before every wedding event to ensure safety and comfort for all passengers.',
    },
];

const testimonials = [
    {
        name: "Mr. Rahul Deshpande",
        position: "Groom",
        text: "Prince Cabs provided a beautifully decorated Innova for our wedding day in Pune. The service was punctual, the car was immaculate, and the driver was very professional.",
        image: "/img/testimonial/testimonial-thumb-wedding-1.png",
    },
    {
        name: "Mrs. Pooja Kulkarni",
        position: "Bride’s Sister",
        text: "We hired multiple Innova cabs for our wedding guests. Everyone was impressed with the comfort and decor. Highly recommend Prince Cabs for wedding travel in Pune!",
        image: "/img/testimonial/testimonial-thumb-wedding-2.png",
    },
];




































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Cab for Wedding in Pune",
  "image": "https://princecab.com/assets/images/innova-wedding-cab-pune.jpg",
  "description": "Book Innova Crysta cab for weddings in Pune with Prince Cabs. Luxury, spacious 7-seater cabs with bridal car decoration and affordable wedding packages.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.75",
    "ratingCount": "7200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/innova-cab-wedding-pune"
  }
};



    return (
        <div>
<Helmet>
  <title>Innova Cab for Wedding in Pune | Luxury Wedding Car Rental | Prince Cabs</title>
  <meta
    name="description"
    content="Book Innova Crysta cab for weddings in Pune with Prince Cabs. Luxury, spacious 7-seater cabs with bridal car decoration and affordable wedding packages."
  />
  <meta
    name="keywords"
    content="Innova Crysta for Wedding, Innova Hire for Wedding, Innova Crysta Wedding Car Rental Pune, Innova Crysta Package, Innova Cab on Rent for Wedding in Pune, Toyota Innova Crysta Cab for Marriage, Luxury Innova Wedding Cab, 7 Seater Innova for Marriage Pune, Innova Crysta Bridal Car, Innova Wedding Car Decoration Pune, Affordable Innova Wedding Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacabforweddinginpune;